import React from "react";
import { useLanguageContext } from "../../../Context/LanguageContext";
import commonUtils from "../../../helpers/commonUtils";
import { NavLink } from "react-router-dom";
import {
  useEquipmentStatusActionsContext,
  useItemSelectedFilterActionsContext,
} from "../../../Context/GridEquipListContext";
import { useMainGridSortActionContext } from "../../../Context/GlobalContext";
import { Typography } from "@mui/material";
export default function NavigationBarNavLink({
  handleContentChange,
  userProfile,
}) {
  const { localization } = useLanguageContext();
  const updateEquipmentStatus = useEquipmentStatusActionsContext();
  const UpdateSortBy = useMainGridSortActionContext();
  const updateListSelectedFilter = useItemSelectedFilterActionsContext();
  const topNavItems = [
    {
      lable: localization.dashboard,
      path: "/dashboard",
      show:
        commonUtils.isUserOrganisationAdmin() || commonUtils.isUserWerkAdmin(),
      showSetting: "dashboard",
      sortCol: { key: "InventarNr", order: "asc" },
    },
    {
      lable: localization.equipment,
      path: "/equipmentGrpEqiupment",
      show:
        commonUtils.isUserOrganisationAdmin() ||
        commonUtils.isUserWerkAdmin() ||
        commonUtils.isPrufer() ||
        commonUtils.isAdmin() ||
        commonUtils.isReader(),

      showSetting: "equipmentGrpEqiupment",

      sortCol: { key: "InventarNr", order: "asc" },
    },
    {
      lable: localization.inspection,
      path: "/inspection",
      show:
        commonUtils.isUserOrganisationAdmin() ||
        commonUtils.isUserWerkAdmin() ||
        commonUtils.isPrufer() ||
        commonUtils.isAdmin() ||
        commonUtils.isReader(),

      showSetting: "equipmentGrpEqiupment",
      sortCol: { key: "InventarNr", order: "asc" },
    },
    {
      lable: localization.settings,
      path: "/setting",
      show:
        commonUtils.isUserOrganisationAdmin() ||
        commonUtils.isUserWerkAdmin() ||
        commonUtils.isAdmin(),
      showSetting: "setting",
      sortCol: { key: "InventarNr", order: "asc" },
    },

    {
      lable: localization.manageTicket,
      path: "/setting/ManageTicket",
      show:
        commonUtils.hasManageTicketPermission() &&
        !commonUtils.isUserOrganisationAdmin() &&
        !commonUtils.isUserWerkAdmin() &&
        !commonUtils.isAdmin(),

      sortCol: { key: "InventarNr", order: "asc" },
    },
  ];
  return (
    <div className="d-flex flex-grow-1" id="navgiationBartab">
      <nav className="navbar navbar-expand-lg navbar-light">
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbar"
          aria-controls="navbar"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Configuration Menu start */}
        <div className="collapse navbar-collapse firstItemNav" id="navbar">
          <ul className="navbar-nav" style={{ fontSize: "20px" }}>
            {topNavItems.map((_link, index) => {
              if (_link.show) {
                return (
                  <li key={index} className="nav-item ">
                    <NavLink
                      className={({ isActive }) =>
                        isActive ? "nav-link active" : "nav-link"
                      }
                      style={{ textDecoration: "none" }}
                      to={_link.path}
                      onClick={(e) => {
                        updateEquipmentStatus("not");
                        UpdateSortBy(_link.sortCol);
                        updateListSelectedFilter([]);
                        handleContentChange(_link.showSetting);
                      }}
                    >
                      {" "}
                      <Typography variant="title-md">{_link.lable}</Typography>
                    </NavLink>
                  </li>
                );
              }
            })}
          </ul>
        </div>
        {/* Configuration Menu end*/}
        <div className="collapse navbar-collapse" id="navbar">
          <ul className="navbar-nav"></ul>
        </div>
        <div className="collapse navbar-collapse" id="navbar"></div>
        <div className="collapse navbar-collapse" id="navbar"></div>

        <div className="collapse navbar-collapse"></div>

        <span></span>
      </nav>
      {userProfile}
    </div>
  );
}
